import '@popperjs/core';
import 'bootstrap';
window.Modal = require('bootstrap/js/dist/modal');
window.Alert = require('bootstrap/js/dist/alert');

$.fn.dataTable.moment('MMM. D, YYYY, h:mm a');
